module.exports = __webpack_public_path__ + "static/media/contactBg.c647d84e.png";